import { Box, Grid, Paper } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { LinearProgress, Button, Icon, CircularProgress, Typography } from "@mui/material";
import { FormHandles } from "@unform/core";
import * as yup from 'yup';

import { List, Card, CardHeader, ListItem, ListItemText, ListItemIcon, Checkbox, Divider } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';

import { AlertSnackBar, AutoCompleteDeCliente, AutoCompleteDeUnidade, FerramentaDeDetalhe } from "../../shared/components";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { VTextField, VForm, useVForm } from "../../shared/forms";
import { VSwitch } from "../../shared/forms/VSwitch";
import { PerfilService } from "../../shared/services/api/perfil/PerfilService";
import { Environment } from "../../shared/environment";
import { TipoService, IListagemTipo, RenderTree, ITipo, RenderTreeIndice } from "../../shared/services/api/tipo/TipoService";
import { ISetor } from "../../shared/services/api/setor/SetorService";
import { Detalhe_Caixa_Service } from "../../shared/services/api/caixa/Detalhe_Caixa_Service";
import { IPesquisaPermissao, PermissaoService } from "../../shared/services/api/permissões/PermissaoService";
import { IUnidade, UnidadeService } from "../../shared/services/api/unidade/UnidadeService";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";
import { useAppThemeContext } from "../../shared/contexts";

interface IFormData {
    nomePerfil: string,
    abrir: boolean,
    // consultar: boolean,
    alterar: boolean,
    excluir: boolean,
    mesclar: boolean,
    indexar: boolean,
    // enviarEmail: boolean,
    // consultarDesativado: boolean,
    cnpj: string,
}
interface IFormValidation {
    nomePerfil: string,
    abrir: boolean,
    // consultar: boolean,
    alterar: boolean,
    excluir: boolean,
    mesclar: boolean,
    indexar: boolean,
    // enviarEmail: boolean,
    // consultarDesativado: boolean,
}

const formValidationSchema: yup.SchemaOf<IFormValidation> = yup.object().shape({
    nomePerfil: yup.string().required("O nome do perfil é obrigatório"),
    abrir: yup.bool().required().default(false),
    consultar: yup.bool().required().default(false),
    alterar: yup.bool().required().default(false),
    excluir: yup.bool().required().default(false),
    mesclar: yup.bool().required().default(false),
    indexar: yup.bool().required().default(false),
    enviarEmail: yup.bool().required().default(false),
    consultarDesativado: yup.bool().required().default(false),
});

export const DetalheDePerfil: React.FC = () => {
    const { idPerfil = 'novo' } = useParams<'idPerfil'>();
    const navigate = useNavigate();
    const dataFetchedRef = useRef(false);

    const { themeName } = useAppThemeContext();

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();


    const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [isLoading, setIsLoading] = useState(false);
    const [nome, setNome] = useState('');

    const [permissao, setPermissao] = useState<IPesquisaPermissao>();

    useEffect(() => {
        if (localStorage.getItem("cnpj") === null || localStorage.getItem("cnpj") === "" || localStorage.getItem("cnpj") === undefined) {
            navigate(-1);
        } else {
            setCnpj(localStorage.getItem("cnpj"));
        }
    }, [localStorage.getItem("cnpj")])

    useEffect(() => {
        if (idPerfil !== 'novo') {
            if (dataFetchedRef.current) return;// se ja tiver pego os dados volta(previnir que renderize mais de uma vez)
            dataFetchedRef.current = true;

            setIsLoading(true);
            setNome("Carregando...");

            PerfilService.getById(Number(idPerfil)).then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                    // se der erro, volta para a listagem para não ficar uma tela em branco
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                    navigate('/perfil');
                } else {
                    setNome(result.nomePerfil);
                    setCnpj(result.cnpj);
                    formRef.current?.setData(result);

                    setIsLoadingListaUnidades(true);
                    setIsLoadingListaSetores(true);

                    PermissaoService.getByIdPerfil(Number(idPerfil)).then((resultPermissao) => {
                        if (resultPermissao instanceof Error) {
                            // se der erro, volta para a listagem para não ficar uma tela em branco
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: resultPermissao.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                            setIsLoadingListaUnidades(false);
                            setIsLoadingListaSetores(false);
                        } else {
                            if (resultPermissao.setor.length < 1) {
                                setIsLoadingListaSetores(false);
                            }
                            var auxExpandir: string[] = resultPermissao.tipo.toString().split(",");
                            var todosSetores: number[] = [];
                            var todasUnidades: number[] = [];

                            setPermissao(resultPermissao);

                            resultPermissao.unidade.map(unidade => {
                                todasUnidades.push(unidade.idUnidade)
                            });

                            resultPermissao.setor.map(setor => {
                                todosSetores.push(setor.idSetor)
                            });

                            todasUnidades.map(idUnidade => {
                                auxExpandir.push("Unidade-" + idUnidade);
                            })

                            todosSetores.map(idSetor => {
                                auxExpandir.push("Setor-" + idSetor);
                            });
                            var auxTipo = resultPermissao.tipo.toString().split(",").map(idTipo => `tipo_${idTipo}`);
                            setSelectedIdsTipo_Indice(resultPermissao.indice.toString().split(","));
                            auxTipo.map(nodeIdTipo => auxExpandir.push(nodeIdTipo));
                            setExpanded(auxExpandir);
                            UnidadeService.list(result.cnpj).then((resultUnidade) => {
                                setIsLoadingListaUnidades(false);
                                if (resultUnidade instanceof Error) {//verificar se deu erro
                                    setAlertSnackbar({ tipoAlert: "erro", mensagem: resultUnidade.message });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);
                                }
                                else {
                                    setUnidades(resultUnidade);
                                }
                            });
                        }
                    });
                }
            });

        } else {
            formRef.current?.setData({
                nomePerfil: '',
            });
        }
    }, [idPerfil]);

    //-------------------------------------------------------------------------------  Parte do transfer list -------------------------------------------------------------------------------
    interface ListaUnidades {
        idUnidade: number;
        nomeUnidade: string;
    }

    function unidadesNot(a: readonly ListaUnidades[], b: readonly ListaUnidades[]) {
        return a.filter((unidade) => b.indexOf(unidade) === -1);
    }

    function unidadesIntersection(a: readonly ListaUnidades[], b: readonly ListaUnidades[]) {
        return a.filter((unidade) => b.indexOf(unidade) !== -1);
    }

    function unidadesUnion(a: readonly ListaUnidades[], b: readonly ListaUnidades[]) {
        return [...a, ...unidadesNot(b, a)];
    }

    const [unidades, setUnidades] = useState<IUnidade[]>([]);
    const [isLoadingListaUnidades, setIsLoadingListaUnidades] = useState(false);

    useEffect(() => {// carregar as unidades na lista

        if (idPerfil === "novo") {
            if (cnpj !== undefined && cnpj !== null && cnpj !== "") {
                LimparListasUnidades();
                setIsLoadingListaUnidades(true);
                UnidadeService.list(cnpj).then((result) => {
                    setIsLoadingListaUnidades(false);
                    if (result instanceof Error) {//verificar se deu erro
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);
                    }
                    else {
                        setUnidades(result);
                    }
                })
            } else {// limpar as listas ao deselecionar uma unidade 
                LimparListas();
                setSelectedIdsTipo_Indice([]);
                setExpanded([]);
            }
        }

    }, [cnpj]);

    function LimparListasUnidades() {
        setSetores([]);
        LimparTransferListsUnidades();
    }
    function LimparTransferListsUnidades() {
        setUnidadesDisponiveis([]);
        setUnidadesSelecionadas([]);
    }

    const limparCampos = () => {
        formRef.current?.setData({
            nomePerfil: '',
        });
        setNome('');
        LimparListasUnidades();
        LimparTransferListsUnidades();
    }

    const [unidadesChecked, setUnidadesChecked] = useState<readonly ListaUnidades[]>([]);
    const [unidadesDisponiveis, setUnidadesDisponiveis] = useState<ListaUnidades[]>([]);
    const [unidadesSelecionadas, setUnidadesSelecionadas] = useState<ListaUnidades[]>([]);

    const unidadesDisponiveisChecked = unidadesIntersection(unidadesChecked, unidadesDisponiveis);
    const unidadesSelecionadasChecked = unidadesIntersection(unidadesChecked, unidadesSelecionadas);

    const handleToggleUnidade = (setor: ListaUnidades) => () => {
        const currentIndex = unidadesChecked.indexOf(setor);
        const newChecked = [...unidadesChecked];

        if (currentIndex === -1) {
            newChecked.push(setor);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setUnidadesChecked(newChecked);
    };

    const listOfUnidadesChecked = (items: readonly ListaUnidades[]) =>
        unidadesIntersection(unidadesChecked, items).length;

    const handleToggleAllUnidades = (items: readonly ListaUnidades[]) => () => {
        if (listOfUnidadesChecked(items) === items.length) {
            setUnidadesChecked(unidadesNot(unidadesChecked, items));
        } else {
            setUnidadesChecked(unidadesUnion(unidadesChecked, items));
        }
    };

    const handleUnidadesCheckedRight = () => {
        setUnidadesSelecionadas(unidadesSelecionadas.concat(unidadesDisponiveisChecked));
        setUnidadesDisponiveis(unidadesNot(unidadesDisponiveis, unidadesDisponiveisChecked));
        setUnidadesChecked(unidadesNot(unidadesChecked, unidadesDisponiveisChecked));
    };

    const handleUnidadesCheckedLeft = () => {
        setUnidadesDisponiveis(unidadesDisponiveis.concat(unidadesSelecionadasChecked));
        setUnidadesSelecionadas(unidadesNot(unidadesSelecionadas, unidadesSelecionadasChecked));
        setUnidadesChecked(unidadesNot(unidadesChecked, unidadesSelecionadasChecked));
    };

    useEffect(() => {// colocar os setores na lista de disponiveis
        unidades.map(unidade => setUnidadesDisponiveis((prevUnidades) => [...prevUnidades, { idUnidade: unidade.idUnidade, nomeUnidade: unidade.nomeUnidade }]));// coloca todos os unidades na lista de disponivelSetor
        if (idPerfil !== "novo" && permissao !== undefined) {
            unidades.map((unidade, index) => {
                permissao.unidade.map(unidade_permissao => {


                    if (unidade.idUnidade === unidade_permissao.idUnidade) {// se o perfil  tem esse unidade
                        setUnidadesSelecionadas((prevUnidades) => [...prevUnidades, { idUnidade: unidade.idUnidade, nomeUnidade: unidade.nomeUnidade }]);// adiciona na lista de selecionados
                        setUnidadesDisponiveis((current) => current.filter((disponivelUnidade) => disponivelUnidade.idUnidade !== unidade.idUnidade));// remove da lista de disponiveis;
                    }

                });
                if (index === unidades.length - 1) setIsLoadingListaUnidades(false);
            });
        }
    }, [unidades]);

    const customListUnidades = (title: React.ReactNode, items: readonly ListaUnidades[]) => (
        <Card sx={{ border: 1 }}>
            <CardHeader
                sx={{ px: 2, py: 1 }}
                avatar={
                    <Checkbox
                        onClick={handleToggleAllUnidades(items)}
                        checked={listOfUnidadesChecked(items) === items.length && items.length !== 0}
                        indeterminate={
                            listOfUnidadesChecked(items) !== items.length && listOfUnidadesChecked(items) !== 0
                        }
                        disabled={items.length === 0}
                    />
                }
                title={title}
                subheader={`${listOfUnidadesChecked(items)}/${items.length} selecionados`}
            />
            <Divider />
            <List
                sx={{
                    width: 220,
                    height: 230,
                    bgcolor: 'background.paper',
                    overflow: 'auto',
                }}
                dense
                component="div"
                role="list"
            >
                {isLoadingListaUnidades ? (
                    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> <CircularProgress /> </Box>
                ) : (
                    <>{items.map((value: ListaUnidades) => {
                        const labelId = `transfer-list-all-item-${value}-label`;

                        return (
                            <ListItem
                                key={value.idUnidade}
                                role="listitem"
                                onClick={handleToggleUnidade(value)}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={unidadesChecked.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.nomeUnidade} />
                            </ListItem>
                        );
                    })}</>
                )}

                <ListItem />
            </List>
        </Card>
    );
    //--------------------------------------------------------------------------------------------------------------------------------------------------------------
    interface ListaSetores {
        idSetor: number;
        idUnidade: number;
        nomeSetor: string;
        disabled: boolean;
    }

    function setoresNot(a: readonly ListaSetores[], b: readonly ListaSetores[]) {
        return a.filter((setor) => b.indexOf(setor) === -1);
    }

    function setoresIntersection(a: readonly ListaSetores[], b: readonly ListaSetores[]) {
        return a.filter((setor) => b.indexOf(setor) !== -1);
    }

    function setoresUnion(a: readonly ListaSetores[], b: readonly ListaSetores[]) {
        return [...a, ...setoresNot(b, a)];
    }

    const [setores, setSetores] = useState<ISetor[]>([]);
    const [isLoadingListaSetores, setIsLoadingListaSetores] = useState(false);

    useEffect(() => {// carregar os setores na lista

        if (unidadesSelecionadas.length > 0) {
            LimparListas();
            setIsLoadingListaSetores(true);
            var arrayIds: number[] = [];
            unidadesSelecionadas.map(unidade => {
                arrayIds.push(unidade.idUnidade);
            });
            PermissaoService.getSetoresByIdsUndidade(arrayIds).then((result) => {
                setIsLoadingListaSetores(false);
                if (result instanceof Error) {//verificar se deu erro
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {
                    setSetores(result);
                }
            })
        } else {// limpar as listas ao deselecionar uma unidade 
            LimparListas();
            setSelectedIdsTipo_Indice([]);
            setExpanded([]);
        }

    }, [unidadesSelecionadas]);

    function LimparListas() {
        setSetores([]);
        setSetoresDisponiveis([]);
        setSetoresSelecionados([]);
    }
    function LimparTransferLists() {
        setSetoresDisponiveis([]);
        setSetoresSelecionados([]);
    }

    const [setoresChecked, setSetoresChecked] = useState<readonly ListaSetores[]>([]);
    const [setoresDisponiveis, setSetoresDisponiveis] = useState<ListaSetores[]>([]);
    const [setoresSelecionados, setSetoresSelecionados] = useState<ListaSetores[]>([]);

    const setoresDisponiveisChecked = setoresIntersection(setoresChecked, setoresDisponiveis);
    const setoresSelecionadosChecked = setoresIntersection(setoresChecked, setoresSelecionados);

    const handleToggleSetores = (setor: ListaSetores) => () => {
        const currentIndex = setoresChecked.indexOf(setor);
        const newChecked = [...setoresChecked];

        if (currentIndex === -1) {
            newChecked.push(setor);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSetoresChecked(newChecked);
    };

    const listOfSetoresChecked = (items: readonly ListaSetores[]) =>
        setoresIntersection(setoresChecked, items).length;

    const handleToggleAllSetores = (items: readonly ListaSetores[]) => () => {
        if (listOfSetoresChecked(items) === items.length) {
            setSetoresChecked(setoresNot(setoresChecked, items));
        } else {
            setSetoresChecked(setoresUnion(setoresChecked, items));
        }
    };

    const handleSetoresCheckedRight = () => {
        setSetoresSelecionados(setoresSelecionados.concat(setoresDisponiveisChecked));
        setSetoresDisponiveis(setoresNot(setoresDisponiveis, setoresDisponiveisChecked));
        setSetoresChecked(setoresNot(setoresChecked, setoresDisponiveisChecked));
    };

    const handleSetoresCheckedLeft = () => {
        setSetoresDisponiveis(setoresDisponiveis.concat(setoresSelecionadosChecked));
        setSetoresSelecionados(setoresNot(setoresSelecionados, setoresSelecionadosChecked));
        setSetoresChecked(setoresNot(setoresChecked, setoresSelecionadosChecked));
    };

    useEffect(() => {// colocar os setores na lista de disponiveis
        LimparTransferLists();// limpar as listas ao selecionar uma unidade diferente
        setores.map(setor => setSetoresDisponiveis((prevSetores) => [...prevSetores, { idSetor: setor.idSetor, idUnidade: setor.idUnidade, nomeSetor: setor.nomeSetor, disabled: false }]));// coloca todos os setores na lista de disponivelSetor
        if (idPerfil !== "novo" && permissao !== undefined) {
            setores.map((setor, index) => {
                permissao.setor.map(permissao => {


                    if (setor.idSetor === permissao.idSetor) {// se o perfil  tem esse setor
                        setSetoresSelecionados((prevSetores) => [...prevSetores, { idSetor: setor.idSetor, idUnidade: setor.idUnidade, nomeSetor: setor.nomeSetor, disabled: true }]);// adiciona na lista de selecionados
                        setSetoresDisponiveis((current) => current.filter((disponivelSetor) => disponivelSetor.idSetor !== setor.idSetor));// remove da lista de disponiveis;
                    }

                });
                if (index === setores.length - 1) setIsLoadingListaSetores(false);
            });
        }
    }, [permissao, setores]);

    const customListSetores = (title: React.ReactNode, items: readonly ListaSetores[]) => (
        <Card sx={{ border: 1 }}>
            <CardHeader
                sx={{ px: 2, py: 1 }}
                avatar={
                    <Checkbox
                        onClick={handleToggleAllSetores(items)}
                        checked={listOfSetoresChecked(items) === items.length && items.length !== 0}
                        indeterminate={
                            listOfSetoresChecked(items) !== items.length && listOfSetoresChecked(items) !== 0
                        }
                        disabled={items.length === 0}
                    />
                }
                title={title}
                subheader={`${listOfSetoresChecked(items)}/${items.length} selecionados`}
            />
            <Divider />
            <List
                sx={{
                    width: 220,
                    height: 230,
                    bgcolor: 'background.paper',
                    overflow: 'auto',
                }}
                dense
                component="div"
                role="list"
            >
                {isLoadingListaSetores ? (
                    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> <CircularProgress /> </Box>
                ) : (
                    <>{items.map((value: ListaSetores) => {
                        const labelId = `transfer-list-all-item-${value}-label`;

                        return (
                            <ListItem
                                key={value.idSetor}
                                role="listitem"
                                onClick={handleToggleSetores(value)}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={setoresChecked.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.nomeSetor} />
                            </ListItem>
                        );
                    })}</>
                )}

                <ListItem />
            </List>
        </Card>
    );
    //-------------------------------------------------------------------------------  Fim da parte do transfer list -------------------------------------------------------------------------------

    const [isLoadingTipo, setIsLoadingTipo] = useState(false);
    const [rowsTipo, setRowsTipo] = useState<Array<{ idSetor: number, tipos: IListagemTipo[] }>>([]);
    interface ISetorComoTreeItem {
        nodeId: string,
        label: string,
        idUnidade: number,
        tipos: IListagemTipo[]
    }
    const [unidadeSetores, setUnidadeSetores] = useState<Array<{ nodeId: string, label: string, setores: ISetorComoTreeItem[] }>>([]);
    const [selectedIdsTipo_Indice, setSelectedIdsTipo_Indice] = useState<string[]>([]);
    const [todosIdsTipo_Indice, setTodosIdsTipo_Indice] = useState<string[]>([]);
    const [todosTipos_Indice, setTodosTipos_Indice] = useState<ITipo[]>([]);
    const [expanded, setExpanded] = useState<string[]>([]);
    const [selectedIdsTipo, setSelectedIdsTipo] = useState<string[]>([]);
    // aqui

    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleSelectAll = () => {
        selectedIdsTipo_Indice.length === 0 ? setSelectedIdsTipo_Indice(todosIdsTipo_Indice) : setSelectedIdsTipo_Indice([]);
    }

    const handleSelectTipo = (event: React.SyntheticEvent, nodeIds: string[]) => {
        const regex = /^[0-9\b]+$/;// para não entrar os setores que tambem estão na tree view
        nodeIds = nodeIds.filter(id => regex.test(id));
        var ids: string[] = [];
        var tipos = todosTipos_Indice.flat(Infinity);
        nodeIds.map(idTipo => {
            //@ts-expect-error
            var auxIf: string[] = [].concat(...tipos.map(x => x.tipo_indices.map((tipo_indice: { idTipo_indice: number; }) => tipo_indice.idTipo_indice.toString())));
            if (auxIf.includes(idTipo)) {
                ids.push(idTipo.toString());
            }
        });

        ids = ids.filter((element, index) => {// remover duplicação
            return ids.indexOf(element) === index;
        });

        setSelectedIdsTipo_Indice(ids);
    };

    const handleToggleTipo = (event: React.SyntheticEvent, nodeIds: string[]) => {
        let expanded = nodeIds.filter((element, index) => {// remover duplicação
            return nodeIds.indexOf(element) === index;
        });
        setExpanded(expanded);
    };

    useEffect(() => {
        setRowsTipo([]);
        if (setoresSelecionados.length > 0) {
            setIsLoadingTipo(true);
            var auxRowsTipo: Array<{ idSetor: number, tipos: IListagemTipo[] }> = [];
            var auxTodosTipos: ITipo[] = [];
            var auxTodosIdsTipos: string[] = [];
            var index = 0;
            setoresSelecionados.map(setor => {
                PermissaoService.getTipos(setor.idSetor).then((result) => {
                    setIsLoadingTipo(false);

                    if (result instanceof Error) {//verificar se deu erro
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);
                    }
                    else {
                        auxRowsTipo.push({
                            idSetor: setor.idSetor,
                            tipos: result.raiz,
                        });
                        //@ts-expect-error
                        result.data.map(tipo => {
                            // auxTodosIdsTipos.push((tipo.idTipo).toString());
                            // auxTodosIdsTipos.push((tipo.tipo_indices.map(tipo_indice => tipo_indice.idTipo_indice)).toString());
                            tipo.tipo_indices.map((tipo_indice: { idTipo_indice: any; }) => {
                                auxTodosIdsTipos.push(tipo_indice.idTipo_indice.toString())
                            })
                        });
                        auxTodosTipos.push(result.data);

                        if (setoresSelecionados.length - 1 === index) {
                            setRowsTipo(auxRowsTipo);
                            setTodosTipos_Indice(auxTodosTipos);
                            setTodosIdsTipo_Indice(auxTodosIdsTipos);

                            var auxUnidadeSetores: Array<{ nodeId: string, label: string, setores: ISetorComoTreeItem[] }> = [];
                            unidadesSelecionadas.map(unidade => {
                                var auxSetorTipos: ISetorComoTreeItem[] = [];
                                setoresSelecionados.map(setor => {
                                    auxRowsTipo.map(rowTipo => {
                                        if (rowTipo.idSetor === setor.idSetor) {
                                            auxSetorTipos.push(
                                                {
                                                    nodeId: `Setor-${setor.idSetor}`,
                                                    idUnidade: setor.idUnidade,
                                                    label: setor.nomeSetor,
                                                    tipos: rowTipo.tipos,
                                                },
                                            );
                                        }
                                    });
                                });

                                var auxSetores: ISetorComoTreeItem[] = [];
                                auxSetorTipos.map(setor => {
                                    if (setor.idUnidade === unidade.idUnidade) {
                                        auxSetores.push(setor);
                                    }
                                });
                                if (setores.length > 0) {
                                    auxUnidadeSetores.push(
                                        {
                                            'nodeId': "Unidade-" + unidade.idUnidade,
                                            'label': unidade.nomeUnidade,
                                            'setores': auxSetores,
                                        },
                                    );
                                }
                            });
                            setUnidadeSetores(auxUnidadeSetores);
                        }
                    }
                    index++;
                });
            });
        }
    }, [setoresSelecionados])


    const renderTree = (nodes: RenderTreeIndice, id: number) =>
    (
        <TreeItem key={`indice_${id}`} nodeId={id.toString()} label={nodes.nomeIndice} />
    );

    const [openDialog, setOpenDialog] = useState(false);
    //-------------------------------------------------------------------------------  Fim da parte dos tipos -------------------------------------------------------------------------------

    const handleSave = (dados: IFormData) => {
        if (cnpj === undefined || cnpj === null || cnpj == '') {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione um cliente" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        } else {
            dados.cnpj = cnpj;
            formValidationSchema.validate(dados, { abortEarly: false }).then(() => {
                setIsLoading(true);
                if (idPerfil === 'novo') {
                    PerfilService.create(dados).then((result) => {
                        setIsLoading(false);
                        if (result instanceof Error) {
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);
                        } else {
                            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Perfil criado" });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                            // coloca um if do salvar e voltar aqui quando permirtir que n tenha que bloquear no minimo um

                            var dadosPermissao: number[] = [];
                            // selectedIdsTipo.map(id => {
                            //     var tipo = todosTipos.flat(Infinity).filter(tipo => tipo.idTipo === Number(id));
                            //     if (tipo.length > 0 && (setoresSelecionados.some(setor => setor.idSetor === tipo[0].idSetor))) {
                            //         dadosPermissao.push(Number(id))
                            //     }
                            // });
                            selectedIdsTipo_Indice.map(id => {
                                dadosPermissao.push(Number(id));
                            });
                            if (dadosPermissao.length != 0) {
                                PermissaoService.create(result, dadosPermissao).then((resultPermissao) => {
                                    setIsLoading(false);
                                    if (resultPermissao instanceof Error) {
                                        setAlertSnackbar({ tipoAlert: "erro", mensagem: resultPermissao.message });
                                        setTimeout(() => {
                                            setAlertSnackbar(undefined);
                                        }, duracaoAlert);
                                    } else {
                                        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Permissões criadas" });
                                        setTimeout(() => {
                                            setAlertSnackbar(undefined);
                                        }, duracaoAlert);

                                        // salvar e voltar
                                        if (isSaveAndReturn()) {
                                            navigate(-1)
                                        } else {
                                            limparCampos();
                                        }
                                    }
                                });
                            } else {
                                // salvar e voltar
                                if (isSaveAndReturn()) {
                                    navigate(-1)
                                } else {
                                    limparCampos();
                                }
                            }

                        }
                    });

                } else {
                    PerfilService.updateById({ idPerfil: Number(idPerfil), ...dados }).then((result) => {
                        setIsLoading(false);
                        if (result instanceof Error) {
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);
                        } else {
                            setNome(dados.nomePerfil);
                            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Perfil Alterado" });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                        }
                        var dadosPermissao: number[] = [];
                        // selectedIdsTipo_Indice.map(id => {
                        //     var tipo = todosTipos_Indice.flat(Infinity).filter(tipo => tipo.idTipo === Number(id));
                        //     if (tipo.length > 0 && (setoresSelecionados.some(setor => setor.idSetor === tipo[0].idSetor))) {
                        //         dadosPermissao.push(Number(id));
                        //     }
                        // });
                        selectedIdsTipo_Indice.map(id => {
                            dadosPermissao.push(Number(id));
                        });
                        PermissaoService.create(Number(idPerfil), dadosPermissao).then((resultPermissao) => {
                            setIsLoading(false);
                            if (resultPermissao instanceof Error) {
                                setAlertSnackbar({ tipoAlert: "erro", mensagem: resultPermissao.message });
                                setTimeout(() => {
                                    setAlertSnackbar(undefined);
                                }, duracaoAlert);
                            } else {
                                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Permissões alteradas" });
                                setTimeout(() => {
                                    setAlertSnackbar(undefined);
                                }, duracaoAlert);
                            }
                        });

                        if (isSaveAndReturn()) {
                            navigate(-1)
                        }
                    });
                }

            }).catch((errors: yup.ValidationError) => {
                const validationErrors: { [key: string]: string } = {};

                errors.inner.forEach(error => {
                    if (!error.path) return;
                    validationErrors[error.path] = error.message;
                });

                formRef.current?.setErrors(validationErrors);
            });
        }
    }
    const handleDelete = () => {
        PerfilService.toggleEnabledById(Number(idPerfil)).then(result => {
            if (result instanceof Error) {//verificar se deu erro
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Registro desativado com sucesso" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
                navigate('/perfil');
            }
        });
    }

    const [abrir, setAbrir] = useState(false);

    const handleCancel = () => {
        setAbrir(false);
    };

    // Função recursiva para renderizar tipos e subtipos
    const renderTipo = (tipo: any) => (
        <TreeItem key={`tipo_${tipo.idTipo}`} nodeId={`tipo_${tipo.idTipo}`} label={tipo.nomeTipo}>
            {/* Renderiza os índices desse tipo */}
            {tipo.tipo_indices?.map((tipo_indice: any) =>
                renderTree(tipo_indice.indice, tipo_indice.idTipo_indice)
            )}

            {/* Se houver subtipos, chama recursivamente */}
            {tipo.tipos?.map((subtipo: any) => renderTipo(subtipo))}
        </TreeItem>
    );


    return (

        <LayoutBaseDePagina
            titulo={idPerfil == 'novo' ? 'Novo perfil' : nome}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoSalvarEVoltar
                    mostrarBotaoApagar={idPerfil !== 'novo'}
                    mostrarBotaoNovo={idPerfil !== 'novo'}

                    mostrarBotaoNovoCarregando={isLoading}
                    mostrarBotaoApagarCarregando={isLoading}
                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEVoltar={saveAndReturn}
                    aoClicarEmApagar={() => setAbrir(true)}
                    aoClicarEmNovo={() => navigate('/perfil/detalhe/novo')}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            <DialogConfirm
                AoConfirmar={handleDelete}
                titulo={"Dejesa realmente desativar o perfil?"}
                texto={"Ao confirmar, o perfil e suas permissões será desativado."}
                abrir={abrir}
                AoCancelar={handleCancel}
            />
            {alertSnackbar !== undefined && (
                <>
                    {alertSnackbar.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

                <VForm ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>

                        {/* {idPerfil === "novo" && (
                            <Grid container item direction="row" spacing={2}>

                                <Grid item xs={12} sm={12} md={6}>
                                    <AutoCompleteDeCliente paraCadastro width={null} selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />
                                </Grid>

                            </Grid>
                        )} */}

                        <Grid container item direction="row" spacing={2}>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={2}>
                                <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nomePerfil" disabled={isLoading} />
                            </Grid>

                        </Grid>
                        <Grid container item direction="row" spacing={2}>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={2}>
                                <VSwitch label="Abrir" disabled={isLoading} name="abrir" />
                                <VSwitch label="Alterar" disabled={isLoading} name="alterar" />
                                <VSwitch label="Excluir" disabled={isLoading} name="excluir" />
                                <VSwitch label="Mesclar" disabled={isLoading} name="mesclar" />
                                <VSwitch label="Indexar" disabled={isLoading} name="indexar" />
                                {/* <VSwitch label="Consultar Desativado" disabled={isLoading} name="consultarDesativado" /> */}
                            </Grid>

                        </Grid>

                        <Box>
                            <Typography sx={{ m: 2 }} align={"center"} variant="h4"> Permissões por Índices </Typography>

                            <Box sx={{ display: { lg: 'block', xl: 'inline-flex' } }} width="100%">
                                <Grid container spacing={2} justifyContent="center" alignItems="center" my={5}>
                                    <Grid item>{customListUnidades('Unidades disponíveis', unidadesDisponiveis)}</Grid>
                                    <Grid item>
                                        <Grid container direction="column" alignItems="center">
                                            <Button
                                                sx={{
                                                    my: 0.5,
                                                    color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                                    '&.Mui-disabled': {
                                                        color: 'theme.palette.action.disabled',
                                                    },
                                                    borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                                }}
                                                variant="outlined"
                                                size="small"
                                                onClick={handleUnidadesCheckedRight}
                                                disabled={unidadesDisponiveisChecked.length === 0}
                                            >
                                                &gt;
                                            </Button>
                                            <Button
                                                sx={{
                                                    my: 0.5,
                                                    color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                                    '&.Mui-disabled': {
                                                        color: 'theme.palette.action.disabled',
                                                    },
                                                    borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                                }}
                                                variant="outlined"
                                                size="small"
                                                onClick={handleUnidadesCheckedLeft}
                                                disabled={unidadesSelecionadasChecked.length === 0}
                                            >
                                                &lt;
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid item>{customListUnidades("Unidades Selecionadas", unidadesSelecionadas)}</Grid>
                                </Grid>

                                <Grid container spacing={2} justifyContent="center" alignItems="center">
                                    <Grid item>{customListSetores('Setores disponíveis', setoresDisponiveis)}</Grid>
                                    <Grid item>
                                        <Grid container direction="column" alignItems="center">
                                            <Button
                                                sx={{
                                                    my: 0.5,
                                                    color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                                    '&.Mui-disabled': {
                                                        color: 'theme.palette.action.disabled',
                                                    },
                                                    borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                                }}
                                                variant="outlined"
                                                size="small"
                                                onClick={handleSetoresCheckedRight}
                                                disabled={setoresDisponiveisChecked.length === 0}
                                            >
                                                &gt;
                                            </Button>
                                            <Button
                                                sx={{
                                                    my: 0.5,
                                                    color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                                    '&.Mui-disabled': {
                                                        color: 'theme.palette.action.disabled',
                                                    },
                                                    borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                                }}
                                                variant="outlined"
                                                size="small"
                                                onClick={handleSetoresCheckedLeft}
                                                disabled={setoresSelecionadosChecked.length === 0}
                                            >
                                                &lt;
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid item>{customListSetores("Setores Selecionados", setoresSelecionados)}</Grid>
                                </Grid>
                            </Box>
                            <Box display="flex" justifyContent="center" mt={2}>
                                <Button
                                    variant="contained"
                                    disabled={isLoadingTipo || setoresSelecionados.length === 0}
                                    onClick={handleClickOpen}
                                    endIcon={isLoadingTipo ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                                >
                                    Mostrar tipos
                                </Button>
                            </Box>

                        </Box>
                        <Dialog
                            open={openDialog}
                            onClose={handleClose}
                        >
                            <DialogTitle id="scroll-dialog-title"> Tipos </DialogTitle>
                            <DialogContent dividers>
                                {isLoadingTipo ? (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <CircularProgress />
                                    </Box>
                                ) : (
                                    <TreeView
                                        defaultCollapseIcon={<ExpandMoreIcon />}
                                        defaultExpandIcon={<ChevronRightIcon />}
                                        multiSelect
                                        selected={selectedIdsTipo_Indice}
                                        expanded={expanded}
                                        onNodeSelect={handleSelectTipo}
                                        onNodeToggle={handleToggleTipo}
                                        sx={{ width: 500, minHeight: 200, flexGrow: 1 }}
                                    >
                                        {unidadeSetores.map(unidade => (
                                            <TreeItem key={`unidade_${unidade.nodeId}`} nodeId={unidade.nodeId} label={unidade.label}>
                                                {unidade.setores.map(setor => (
                                                    <TreeItem key={`setor_${setor.nodeId}`} nodeId={setor.nodeId} label={setor.label}>
                                                        {setor.tipos.map(tipo => renderTipo(tipo))}
                                                    </TreeItem>
                                                ))}
                                            </TreeItem>
                                        ))}
                                    </TreeView>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Box
                                    width="100%"
                                    marginX={1}
                                    padding={1}
                                    paddingX={2}
                                    gap={1}
                                    display="flex"
                                    justifyContent="center"
                                >
                                    <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleClose}> Fechar </Button>
                                    <Button variant="contained" color="warning" startIcon={<Icon>{selectedIdsTipo_Indice.length === 0 ? 'select_all' : 'deselect'}</Icon>} onClick={handleSelectAll}> {selectedIdsTipo_Indice.length === 0 ? 'Selecionar ' : 'Desselecionar '} tudo </Button>
                                    <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={handleClose}> Confirmar </Button>
                                </Box>
                            </DialogActions>
                        </Dialog>

                    </Grid>
                </VForm>

            </Box>


        </LayoutBaseDePagina>
    )
}